import axios from 'axios';
import isObject from 'lodash/isObject';
const DEFAULT_TIMEOUT = 30000;

const createMockHttpError = (response) => {
  const error = new Error(`Api returned data of type ${typeof response.data} instead of json`);
  error.response = { status: 500 };
  return error;
};

const wrappedAxios = async ({ accessToken, qhUserId, splits, ...options }) => {
  const headers = {};

  if (accessToken) {
    headers.Pragma = 'no-cache';
    headers.Authorization = `Bearer ${accessToken}`;
  }

  if (qhUserId || splits) {
    headers['qh-meta'] = JSON.stringify({
      qhUserId,
      splits,
    });
  }

  const response = await axios({ headers, timeout: DEFAULT_TIMEOUT, ...options });

  if (!isObject(response.data)) {
    throw createMockHttpError(response);
  }

  return response;
};
export default wrappedAxios;
